import * as React from 'react';
import { useEffect, useState } from "react";
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import Table from 'antd/lib/table';
import Dropdown from 'antd/lib/dropdown';
import Button from 'antd/lib/button';
import Menu from 'antd/lib/menu';
import Select from 'antd/lib/select';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import Collapse from 'antd/lib/collapse';
import { Badge, Col, Radio, Row } from 'antd';
import { format } from 'one-util-date';
import { useCtx } from 'one-ui-provider';
import DashIcon from 'one-ui-graphics/svg/dash.svg';
import ChevronUpIcon from 'one-ui-graphics/svg/chevron-up.svg';
import ChevronUpDoubleIcon from 'one-ui-graphics/svg/chevron-up-double.svg';
import ChevronDownIcon from 'one-ui-graphics/svg/chevron-down.svg';
import ChevronDownDoubleIcon from 'one-ui-graphics/svg/chevron-down-double.svg';
import {
  Card
} from 'one-ui-card/src/card';

import {
  IncidentsModel,
} from './model';

import './style.less';

import {
  IncidentCardProps,
} from './props';

import {
NewIncidentModalEnable
} from './newincidentmodal';

const { Panel } = Collapse;

const {
  Option,
} = Select;

export const IncidentsCard = <M extends IncidentsModel>(
  props: IncidentCardProps<M>
)=> {

  const {
    model,
} = props;

const {
    data,
} = model;
const dispatch = useDispatch();
  const [incidentkey, setIncidentKey] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [editincidentvisible, setEditIncidentVisible] = useState(false);
  const [selectedincident, setSelectedIncident] = useState({});
  const [modalvisible,setIsModalVisible] = useState(false)
  const [filterincidents, setfilterIncidents] = useState(data);
  const [incidentsubject, setIncidentSubject] = useState("");
  const [incidentdescription, setIncidentDescription] = useState("");
  const [openedincidentat] = useState("");
  const [incidentnumber,setIncidentNumber] = useState("");
  const [category] = useState([]);
  const [status] =  useState([]);
  const [emailid,setEmailId] = useState("");
  const [number, setNumber] = useState("");
  const servicenowinfo = useSelector((state:any) => (state.servicenowcaller));
  const createincidentsdata = useSelector((state:any)=> (state.createincident));
  const createinteractionsdata = useSelector((state:any)=> (state.createinteraction));
  const { resolver } = useCtx();
  const priorities = ['1 - Critical', '2 - High', '3 - Moderate', '4 - Low', '5 - Planning'];

  const menu = (e: any) => (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key={e.sys_id + ',1'} onClick={() => setSelectedIncident(e)}>Edit Incident</Menu.Item>
      <Menu.Item key={e.sys_id + ',2'} onClick={() => {
        dispatch({
          type:"one-state-linkincidents/fetch",
          payload: {
            interaction: number,
            task: e.number
          }
        });
      }}>Link to this call</Menu.Item>
      {e.state !== 'On Hold' && <Menu.Item key={e.sys_id + ',3'}><a href={`https://dev117142.service-now.com/nav_to.do?uri=incident.do?sys_id=${e.sys_id}`} target="_blank">Open in ServiceNow</a></Menu.Item>}
    </Menu>
  );

  //Table Columns
  const columns = [
    {
      title: 'Date',
      dataIndex: 'sys_created_on',
      key: 'sys_created_on',
      sorter: (a: any, b: any) => a.sys_created_on < b.sys_created_on ? 1 : -1,
      render: (date: Date) => <>{date ? format(date, 'YYYY-MM-DD') : '-'}</>,
    },
    {
      title: 'Incident ID',
      key: 'number',
      dataIndex: 'number',
      sorter: (a: any, b: any) => a.number < b.number ? 1 : -1,
    },
    {
      title: 'Description',
      key: 'short_description',
      dataIndex: 'short_description',
      ellipsis:true
    },
    {
      title: 'Category',
      key: 'category',
      dataIndex: 'category',
      sorter: (a: any, b: any) => a.category < b.category ? 1 : -1,
    },
    {
      title: 'Prioirity',
      key: 'priority',
      dataIndex: 'priority',
      sorter: (a: any, b: any) => a.priority < b.priority ? 1 : -1,
      render: (text: any, record: any) => (
        <span className='legends-item'>
          {record.priority === priorities[0]
            ? <><img className="legends-item-image" src={resolver(ChevronUpDoubleIcon)} draggable="false"/> {record.priority}</>
            : record.priority === priorities[1]
              ? <><img className="legends-item-image" src={resolver(ChevronUpIcon)} draggable="false"/> {record.priority}</>
              : record.priority === priorities[2]
                ? <><img className="legends-item-image" src={resolver(DashIcon)} draggable="false"/> {record.priority}</>
                : record.priority === priorities[3]
                  ? <><img className="legends-item-image" src={resolver(ChevronDownIcon)} draggable="false"/> {record.priority}</>
                  : <><img className="legends-item-image" src={resolver(ChevronDownDoubleIcon)} draggable="false"/> {record.priority}</>}
        </span>
      ),
    },
    {
      title: 'Status',
      key: 'state',
      dataIndex: 'state',
      sorter: (a: any, b: any) => a.state < b.state ? 1 : -1,
      render: (text: any, record: any) => (
        <span className={`incident-status ${record.state === 'Closed' ? 'closed' : ''}`}>{record.state}</span>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text: any, record: any) => (
        <Dropdown overlay={menu(record)}>
          <Button type='link' size='small' className='ant-btn-link--dark'>&hellip;</Button>
        </Dropdown>
      ),
    },
  ];
//To fetch required employee information
  useEffect(() => {
    if (servicenowinfo) {
      let email = servicenowinfo?.selected?.email
      setEmailId(email);
    }
  }, [servicenowinfo]);
//To fetch required incident information
  useEffect(() => {
    if (selectedincident) {

       setIncidentDescription(selectedincident.description)
       setIncidentSubject(selectedincident.short_description)
      setIncidentNumber(selectedincident.number);
    }
}, [selectedincident]);
//To fetch required created interaction information
  useEffect(() => {
    if (createinteractionsdata?.output?.results?.length > 0) {
        createinteractionsdata.output.results.map((interactioninfo:any)=> {
        setNumber(interactioninfo.result.number);
      })
    }
  }, [createinteractionsdata]);
//Handler when we click on Action Button
  const handleMenuClick = (e: any) => {
    let key = e.key;
    let res = key.split(",");
    if (res[1] === '1') {
      setEditIncidentVisible(true);
    }
    else if(res[1] === '2') {
      dispatch({
        type: "one-state-incidents/fetch",
        payload: {
          email: emailid
        }
      });
    }
  }
//Handler to filter table when we enter input in search box
  const handleKeyChange = (event: any) => {
    setIncidentKey(event.target.value);
    if(data?.length > 0) {
      const tablefilter = data.filter((searchdata:any)=> (searchdata.number.includes(event.target.value.toUpperCase()) || searchdata.sys_created_on.includes(event.target.value) || searchdata.short_description.toUpperCase().includes(event.target.value.toUpperCase())))
      setfilterIncidents(tablefilter)
    }
  };
//Handler to filter data when we click on the Radio Buttons
  const handleIncidentFilterChange = (event:any) => {
      if(data?.length > 0) {
        
        const tablefilter =  data.filter((filterchange:any)=> (filterchange.state === event.target.value))
        if(tablefilter?.length >0){
          setfilterIncidents(tablefilter)
        }
        else {
          setfilterIncidents(data)
        }
      }

  }
//Handler for Input Change in Subject 
  const handleIncidentSubject = (event:any) => {
    setIncidentSubject(event.target.value);
  }
//Handler for Input Change in Description 
  const handleIncidentDescription = (event:any) => {
    setIncidentDescription(event.target.value);
  }
//Handler when clicked on New Incident Button
  const handleModalClick = (event:any) => {
    setIsModalVisible(true)
    dispatch({
      type: "one-state-modalvalue/set",
      payload: {
        modalvisible: true
      }
    });
  }
//When we clicked on Save it dispatch the api to Update Incident
  const onOk = () => {

    dispatch({
      type: "one-state-updateincidents/fetch",
      payload: {
        caller_id: emailid,
        category: selectedincident.category,
        description: incidentdescription,
        short_description: incidentsubject,
        state: selectedincident.state,
      }
    });
    dispatch({
      type:"one-state-linkincidents/fetch",
      payload: {
        interaction: number,
        task: incidentnumber
      }
    });
    //To fetch Incident Information
    dispatch({
      type: "one-state-incidents/fetch",
      payload: {
        email: emailid
      }
    });
    setEditIncidentVisible(false);
  };

  const onCancel = () => {
    setIncidentDescription("");
    setIncidentNumber("");
    setIncidentSubject("");
    setEditIncidentVisible(false)
 }
//Radio Filter buttons
  const incidentStatus = [
    {
      id: 'All',
      label: 'All',
      count: data ? data.length : 0,
    },
    {
      id: 'New',
      label: 'New',
      count: data ? data.filter((incident:any) => incident.state === 'New').length : 0,
    },
    {
      id: 'In Progress',
      label: 'In Progress',
      count: data ? data.filter((incident:any) => incident.state === 'In Progress').length : 0,
    },
    {
      id: 'On Hold',
      label: 'On Hold',
      count: data ? data.filter((incident:any) => incident.state === 'On Hold').length : 0,
    },
    {
      id: 'Resolved',
      label: 'Resolved',
      count: data ? data.filter((incident:any) => incident.state === 'Resolved').length : 0,
    },
    {
      id: 'Closed',
      label: 'Closed',
      count: data ? data.filter((incident:any) => incident.state === 'Closed').length : 0,
    },
    {
      id: 'Canceled',
      label: 'Canceled',
      count: data ? data.filter((incident:any) => incident.state === 'Canceled').length : 0,
    },
  ];

  return (
    <>
      <Card
      title=''
      body={(
        <Row gutter={[0, 16]}>
          <Col>
            <Row type="flex" gutter={[16, 32]}>
              <Col>
                <Input size="default" placeholder="Search By Date or Incident Number or Description" value={incidentkey}  onChange={handleKeyChange} className='incident_search' />
              </Col>
              <Col>
                <Button type="primary" onClick={handleModalClick} className='new-incident-button' >
                  New Incident
                </Button>
              </Col>
            </Row>
            <Row gutter={[0, 16]}>
            <Col style={{ flex: 1 }}>
                <Radio.Group
                  size="small" 
                  className="incident-filter"
                  onChange={
                    (event: any) => setSelectedStatus(event.target.value)
                  }
                  value={selectedStatus}
                >
                  {incidentStatus.map(({ label, id, count }) => (
                    <Badge
                    showZero
                    count={count}
                  >
                    <Radio.Button
                      value={id}
                      key={id}
                      onChange={handleIncidentFilterChange}
                    >
                      {label}
                    </Radio.Button>
                  </Badge>
                  ))}
                </Radio.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Table columns={columns} dataSource={filterincidents} />
          </Col>
          <Modal
          title={"Update Incident"}
          visible={editincidentvisible}
          centered
          destroyOnClose
          onCancel={onCancel}
          onOk={onOk}
          okButtonProps={{ form: 'new-call-modal', htmlType: 'submit' }}
          okText={"Save"}
          wrapClassName="custom-modal-wrap"
          width={650}
        >
          {createincidentsdata && (
            <div className="flex justify-end mb-5">
              <a
                href={`https://dev117142.service-now.com/nav_to.do?uri=incident.do?sys_id=${createincidentsdata.sys_id}`}
                target="_blank"
                className="open-servicenow-button"
              >
                Show in ServiceNow
              </a>

            </div>
          )}
          <Form id="new-call-modal">
            <Collapse defaultActiveKey={['1', '2']} className="ant-no-border-panel-collapse">
              <Panel header="Call Information" showArrow={false} key="1">
                <Row gutter={[16, 16]}>
                  <Col md={12} span={24}>
                    <text>Caller</text>
                    <Form.Item>
                      <Input name="caller_id" value={selectedincident.caller_id} placeholder="Caller" readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Opened</text>
                    <Form.Item>
                      <Input name="opened_at" value={selectedincident.opened_at} disabled={!openedincidentat} readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Opened by</text>
                    <Form.Item>
                      <Input name="opened_by" value={selectedincident.openedby} placeholder="Opened by" readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Category</text>
                    <Form.Item>
                      <Select placeholder="Category" value={selectedincident.category} disabled>
                        {
                          category ? category.map((categoryoption: any, index: number) => (
                            <Option value={categoryoption} key={index}>{categoryoption}</Option>
                          )) : ""
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col md={12} span={24}>
                    <text>State</text>
                    <Form.Item>
                      <Select placeholder="State" value={selectedincident.state} disabled>
                        {
                          status ? status.map((statusoption: any, index: number) => (
                            <Option value={statusoption} key={index}>{statusoption}</Option>
                          )) : ""
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                </Row>
              </Panel>
              <Panel header="Description" showArrow={false} key="2">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <text>Subject</text>
                    <Form.Item>
                      <Input name="short_description" value={incidentsubject} placeholder="Subject" onChange={handleIncidentSubject} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <text>Description</text>
                    <Form.Item>
                      <TextArea name="description" value={incidentdescription} placeholder="Description" onChange={handleIncidentDescription} />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </Modal>
        <NewIncidentModalEnable visible={modalvisible}/>
        </Row>
      )}
      />
    </>
  );
};
